import { motion } from "framer-motion";
import { Reveal } from "./Reveal";
import { ArrowUpRight } from "lucide-react";
import { COLLECTIONS } from "@/lib/content";

const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export const Collections = () => (
  <section id="collections" data-testid="collections" className="bg-[#FBF9F6] py-24 md:py-40">
    <div className="max-w-[1500px] mx-auto px-6 md:px-12">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16 md:mb-24">
        <Reveal>
          <span className="eyebrow">01 — What we make</span>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-4 max-w-2xl leading-[1.02]">
            Collections for the home <span className="italic text-[#8C7A6B]">and the boardroom.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="text-[#5C5A56] max-w-sm leading-relaxed">
            Four disciplines, one bench. Every piece is a commission — designed to your dimensions, your materials, your space.
          </p>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8">
        {COLLECTIONS.map((c, i) => (
          <Reveal
            key={c.n}
            delay={i * 0.08}
            className={
              i === 0 ? "md:col-span-7 md:row-span-2" :
              i === 1 ? "md:col-span-5" :
              i === 2 ? "md:col-span-5" : "md:col-span-7"
            }
          >
            <button
              data-testid={`collection-${c.title.toLowerCase()}`}
              onClick={() => scrollTo("contact")}
              className="group block w-full text-left"
            >
              <div className={`relative overflow-hidden bg-[#EFECE7] ${i === 0 ? "aspect-[4/5] md:aspect-[3/4]" : "aspect-[16/11]"}`}>
                <motion.img
                  src={c.img}
                  alt={c.title}
                  className="img-cover"
                  whileHover={{ scale: 1.06 }}
                  transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
                />
                <div className="absolute inset-0 bg-[#1A1A1A]/0 group-hover:bg-[#1A1A1A]/10 transition-colors duration-500" />
                <span className="absolute top-5 left-5 text-[#FBF9F6] text-sm tracking-widest mix-blend-difference">{c.n}</span>
              </div>
              <div className="flex items-start justify-between mt-5 gap-4">
                <div>
                  <h3 className="font-serif text-3xl md:text-4xl tracking-tight">{c.title}</h3>
                  <p className="text-[#5C5A56] text-sm md:text-base mt-2 max-w-md leading-relaxed">{c.desc}</p>
                </div>
                <ArrowUpRight className="shrink-0 mt-2 text-[#8C7A6B] group-hover:rotate-45 transition-transform duration-500" size={26} />
              </div>
            </button>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
